import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {ActivityConditionType} from "../../models/activity-condition-type";
import Helpers from "../../utils/helpers";

@Injectable()
export class ActivityConditionTypeControllerService {

  private baseUrl: string = environment.BASE_URL;

  constructor(private http: HttpClient) {
  }

  public getConditionTypes(): Observable<ActivityConditionType[]> {
    return this.http.get(this.baseUrl + "activity_condition_type") as Observable<ActivityConditionType[]>;
  }

  public saveConditionType(conditionTypes: ActivityConditionType[]): Observable<ActivityConditionType[]> {
    Helpers.trimRecursiveObj(conditionTypes);
    const body = JSON.stringify(conditionTypes);
    return this.http.post(this.baseUrl + "activity_condition_type", body) as Observable<ActivityConditionType[]>;
  }

  public updateSortOrder(conditionTypes: ActivityConditionType[]) {
    Helpers.trimRecursiveObj(conditionTypes);
    const body = JSON.stringify(conditionTypes);
    return this.http.put(this.baseUrl + "sort_activity_condition_type", body, {responseType: "text"});
  }
}
